import { useMemo } from 'react';
import { EDUCATOR_UID, EDUCATOR_USERNAME } from '@events/segmentProps';

const useEducatorDetailsSegmentData = ({ educatorProfile }) => {
  return useMemo(() => {
    const { uid, username } = educatorProfile || {};
    const segmentData = {
      [EDUCATOR_UID]: uid,
      [EDUCATOR_USERNAME]: username
    };
    return segmentData;
  }, [educatorProfile]);
};

export default useEducatorDetailsSegmentData;
